import { useState, useEffect } from 'react'
import axios from 'axios'
import { Formik, Form, Field, ErrorMessage } from 'formik'
import * as yup from 'yup'
import { useHistory } from 'react-router-dom'
import { Row, Button, Col, Card, Dropdown, Container } from 'react-bootstrap'

import './CreateCardInfo.css'
import { $api } from '../../../helpers/api'

const CreateCardInfo = () => {
  let history = useHistory()
  const [listOfPosts, setListOfPosts] = useState([])

  const validationSchema = yup.object().shape({
    title_ka: yup.string().required('სათაურის დაწერა აუცილებელია'),
    titleEng: yup.string(),
    imageUrl: yup.string().required('სურათი აუცილებელია'),
    description_ka: yup.string().min(5).max(500).required('სავალდებულო ველი'),
    descriptionEng: yup.string().min(5).max(500).required('სავალდებულო ველი'),
    fullDescription_ka: yup.string().min(10).max(2000).required('სავალდებულო ველი'),
    fullDescriptionEng: yup.string().min(10).max(2000).required('სავალდებულო ველი'),
  })

  const initialValues = {
    title_ka: '',
    titleEng: '',
    imageUrl: '',
    description_ka: '',
    descriptionEng: '',
    fullDescription_ka: '',
    fullDescriptionEng: '',
  }

  const fetchPosts = async () => {
    try {
      const response = await $api.get('/posts')
      setListOfPosts(response.data)
    } catch (error) {
      console.error('Error fetching posts:', error)
    }
  }

  useEffect(() => {
    fetchPosts()
  }, [])

  const onSubmit = async (data, { resetForm }) => {
    try {
      await $api.post('/posts', data)
      resetForm()
      fetchPosts() // Update list without refreshing the page
    } catch (error) {
      console.error('Error creating post:', error)
    }
  }

  const deletePost = async id => {
    try {
      await $api.delete(`/posts/${id}`, {
        headers: { accessToken: localStorage.getItem('accessToken') },
      })
      setListOfPosts(prev => prev.filter(post => post.id !== id)) // Remove post without reloading
    } catch (error) {
      console.error('Error deleting post:', error)
    }
  }

  return (
    <Container>
      <div className='createInfoCard-container'>
        <Formik
          initialValues={initialValues}
          onSubmit={onSubmit}
          validationSchema={validationSchema}>
          {({ isSubmitting }) => (
            <Form>
              <Row>
                <Col>
                  <label>დასახელება ქართულად</label>
                  <ErrorMessage name='title_ka' component='span' />
                  <Field autoComplete='off' name='title_ka' placeholder='Geo title' />
                </Col>
                <Col>
                  <label>დასახელება ინგლისურად</label>
                  <ErrorMessage name='titleEng' component='span' />
                  <Field autoComplete='off' name='titleEng' placeholder='Eng Title' />
                </Col>
              </Row>

              <label>სურათის ლინკი</label>
              <ErrorMessage name='imageUrl' component='span' />
              <Field autoComplete='off' name='imageUrl' placeholder='image URL' />

              <Row>
                <Col>
                  <label>მოკლე აღწერა ქართულად</label>
                  <ErrorMessage name='description_ka' component='span' />
                  <Field autoComplete='off' name='description_ka' placeholder='Geo Description' />
                </Col>
                <Col>
                  <label>მოკლე აღწერა ინგლისურად</label>
                  <ErrorMessage name='descriptionEng' component='span' />
                  <Field autoComplete='off' name='descriptionEng' placeholder='Eng Description' />
                </Col>
              </Row>

              <label>სრული აღწერა ქართულად</label>
              <ErrorMessage name='fullDescription_ka' component='span' />
              <Field
                as='textarea'
                autoComplete='off'
                name='fullDescription_ka'
                placeholder='Geo Full Description'
              />

              <label>სრული აღწერა ინგლისურად</label>
              <ErrorMessage name='fullDescriptionEng' component='span' />
              <Field
                as='textarea'
                autoComplete='off'
                name='fullDescriptionEng'
                placeholder='Eng Full Description'
              />

              <Button variant='primary' type='submit' disabled={isSubmitting}>
                {isSubmitting ? 'Loading...' : 'გამოქვეყნება'}
              </Button>
            </Form>
          )}
        </Formik>

        <div className='posted-news'>
          <div className='edit-news-cards'>
            {listOfPosts.map(post => (
              <Col key={post.id}>
                <div className='admin-information'>
                  <Card style={{ width: '18rem' }}>
                    <Card.Img variant='top' src={post.imageUrl} alt='card-img' />
                    <Card.Body>
                      <Card.Title>{post.title_ka}</Card.Title>
                      <Card.Text>{post.description_ka}</Card.Text>
                      <div className='card-body-row'>
                        <Button variant='primary' onClick={() => history.push(`/News/${post.id}`)}>
                          მეტის ნახვა
                        </Button>

                        <Dropdown className='dropdown-edit-btn'>
                          <Dropdown.Toggle id='dropdown-basic-button' />
                          <Dropdown.Menu>
                            <Dropdown.Item
                              onClick={() => history.push(`/admin/updatecardinfo/${post.id}`)}>
                              ჩასწორება
                            </Dropdown.Item>

                            <Dropdown.Item onClick={() => deletePost(post.id)}>წაშლა</Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                    </Card.Body>
                  </Card>
                </div>
              </Col>
            ))}
          </div>
        </div>
      </div>
    </Container>
  )
}

export default CreateCardInfo
